module.exports = __webpack_public_path__ + "media/images/custom_page/bae173/card-icon2-a6703c848dd29a3c8ec2691039f5a287.png";